<template>
    <Wrapper>
        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12 lg:col-span-7">
                <h1 class="header-1 mb-4"><T t="complaint_report.title" /></h1>
                <ComplaintReportHubspotForm />
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';
import ComplaintReportHubspotForm from '@/components/Forms/ComplaintReportHubspotForm.vue';

export default {
    name: 'ComplaintReport',
    components: {
        Wrapper,
        ComplaintReportHubspotForm,
    },
    asyncData({ i18n }) {
        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('complaint_report.title'), 'complaint-report']);

        return {
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('complaint-report.index'),
            meta: this.$getPageMetaData('complaint-report.index'),
        };
    },
};
</script>

<style></style>
